export default "__VITE_ASSET__C6QFrc9w__"